import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ backgroundColor: "#fff" }}>
          <h1>Something went wrong.</h1>
          <p>
            <a href="/">Click here to return to Vanco Food Admin</a>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
